const func = ($target) => {
	// console.log("Load Qty Input");

	var $controls = $target.find(".controls"),
		$amount = $target.find('[data-id="quantity"]'),
		$minusButton = $target.find(".btn-minus");

	$controls.on("click", function (e) {
		e.preventDefault();
		var $el = $(this),
			value = $amount.val();

		if ($el.hasClass("btn-minus")) {
			value--;
		} else {
			value++;
		}

		if (value < 0) {
			value = 0;
		}

		if (value > 1) {
			$minusButton.css("fill", "");
		} else {
			$minusButton.css("fill", "#bbbbb9");
		}

		$amount.val(value);
	});
};

export default func;
